import { render, staticRenderFns } from "./NutrientAdd.vue?vue&type=template&id=68796d68&scoped=true"
import script from "./NutrientAdd.vue?vue&type=script&lang=js"
export * from "./NutrientAdd.vue?vue&type=script&lang=js"
import style0 from "./NutrientAdd.vue?vue&type=style&index=0&id=68796d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68796d68",
  null
  
)

export default component.exports